module.exports = __webpack_public_path__ + "img/banner.c3edec49.jpg";